// extracted by mini-css-extract-plugin
module.exports = {"element-not-found":"styles_element-not-found__2rc6i"};